import React from 'react';
import { connect } from 'react-redux';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const FromInteracAccountStatusBean = (props) => {
    const { gotIt } = usePageMessages();
    const getText = (text) => {
        return <DangerouslyHtml dangerouslyHtml={text} />;
    };

    return (
        <BaseLayout>
            <InfoPage
                iconName={'zap-80'}
                iconColor={'primary'}
                headerText={props.statusInteracTitle}
                secondaryText={getText(props.statusInteracText)}
                secondarySmallText={getText(props.interacCopyright)}
                buttonRowCaption={props.more}
                buttonRowType={'link'}
                buttonRowHref={'/canada-interac-payment-method'}
                primaryButtonCaption={gotIt}
                primaryButtonType={'link'}
                primaryButtonOnClick={(e) => {
                    e?.preventDefault();
                    props.toggleSpinner(true);
                    window.location.href = AUTH_SEND_MAIN_LINK;
                }}
            />
        </BaseLayout>
    );
};

const mapStateToProps = (state) => {
    return {
        cheque: state.extra.cheque,
        statusFromBankAccountStatusTitle: state.messages.pageMessages.statusFromBankAccountStatusTitle,
        statusFromBankToSend: state.messages.pageMessages.statusFromBankToSend,
        statusInteracTitle: state.messages.pageMessages.statusInteracTitle,
        statusInteracText: state.messages.pageMessages.statusInteracText,
        interacCopyright: state.messages.pageMessages.interacCopyright,
        statusFromBankDetailsButton: state.messages.pageMessages.statusFromBankDetailsButton,
        statusNextButton: state.messages.pageMessages.statusNextButton,
        notNowButton: state.messages.pageMessages.notNowButton,
        more: state.messages.pageMessages.more,
    };
};
export default connect(mapStateToProps)(BasePage(FromInteracAccountStatusBean));
